@if (imageChunks().length) {
<div class="knowledge-images">
  <div class="images-heading">Referenced images</div>
  <div class="images-row">
    @for (chunk of imageChunks(); track chunk.id) {
    @if (imageStates()[chunk.image_id]; as state) {
    @switch (state.status) {
    @case ("loaded") {
    <button class="image-thumb" type="button" (click)="openImage(chunk.image_id)" [title]="chunk.document_name">
      <img [src]="$any(state).src" [alt]="chunk.document_name" />
    </button>
    }
    @case ("error") {
    <div class="image-thumb image-thumb-msg">Unavailable</div>
    }
    @default {
    <div class="image-thumb image-thumb-msg">
      <span nz-icon nzType="loading" nzTheme="outline"></span>
    </div>
    }
    }
    } @else {
    <div class="image-thumb image-thumb-msg">
      <span nz-icon nzType="loading" nzTheme="outline"></span>
    </div>
    }
    }
  </div>
</div>
}

@if (docAggs().length) {
<div class="knowledge-sources">
  <div class="sources-heading">Sources</div>
  <div class="sources-pills">
    @for (doc of docAggs(); track doc.doc_id) {
    <button class="source-pill" type="button" [disabled]="loadingDocId() === doc.doc_id"
      (click)="openDocument(doc)" [title]="doc.doc_name">
      @if (loadingDocId() === doc.doc_id) {
      <span nz-icon nzType="loading" nzTheme="outline" class="source-pill-icon"></span>
      } @else {
      <span nz-icon nzType="file-text" nzTheme="outline" class="source-pill-icon"></span>
      }
      <span class="source-pill-label">{{ doc.doc_name }}</span>
    </button>
    }
  </div>
</div>
}
